import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { Checkbox, IconButton, TableCell, TableRow, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { t } from 'i18next'
import React, { useState } from 'react'
import Cost from '../../../store/types/models/Cost'
import { formatStringDate } from '../../../store/utils/dateUtils'
import CostActionMenu from '../../Popup/CostActionMenu'

interface ProjectDetailsRowProps {
  cost: Cost
  setCostToEdit: React.Dispatch<React.SetStateAction<Cost | null>>
  isLeader: boolean
  isMyCosts: boolean
  duplicateMode: boolean
  selected: Cost[]
  setSelected: React.Dispatch<React.SetStateAction<Cost[]>>
}

const CostRow = ({
  cost,
  setCostToEdit,
  isLeader,
  isMyCosts,
  duplicateMode,
  selected,
  setSelected,
}: ProjectDetailsRowProps) => {
  const [open, setOpen] = useState<boolean>(false)
  const setEditCost = () => {
    setCostToEdit(cost)
  }
  const typesTranslationMapping = {
    HOTEL: 'components.costSidebar.types.hotel',
    LICENSE: 'components.costSidebar.types.license',
    FUEL: 'components.costSidebar.types.fuel',
    SHOPPING: 'components.costSidebar.types.shopping',
    OTHER: 'components.costSidebar.types.other',
  }
  const createTypesTranslationMapping = {
    IMPORT: 'components.costSidebar.createTypes.import',
    MANUAL: 'components.costSidebar.createTypes.manual',
    CYCLIC: 'components.costSidebar.createTypes.cyclic',
    DUPLICATE: 'components.costSidebar.createTypes.duplicate',
  }
  const checkBoxOnchange = () => {
    setSelected(prevSelected => {
      if (selected.some(item => item.id === cost.id)) {
        return prevSelected.filter(item => item.id !== cost.id)
      } else {
        return [...prevSelected, cost]
      }
    })
  }
  return (
    <React.Fragment>
      <TableRow style={{ height: '45px' }}>
        <TableCell align={'center'} sx={{ pl: 1, paddingRight: '0px !important' }}>
          {!duplicateMode ? (
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          ) : (
            <Checkbox
              sx={{ p: '5px' }}
              checked={selected.some(item => item.id === cost.id)}
              onChange={checkBoxOnchange}
            />
          )}
        </TableCell>
        <TableCell onClick={() => setOpen(!open)}>{cost.principal}</TableCell>
        <TableCell onClick={() => setOpen(!open)}>
          {t(typesTranslationMapping[cost.type as keyof typeof typesTranslationMapping])}
        </TableCell>
        <TableCell onClick={() => setOpen(!open)}> {`${(cost.amount * cost.quantity).toFixed(2)} zł`}</TableCell>
        <TableCell align={'center'}>
          <CostActionMenu costId={cost.id} setEditCost={setEditCost} isLeader={isLeader} isMyCosts={isMyCosts} />
        </TableCell>
      </TableRow>
      <TableRow
        sx={{
          backgroundColor: 'background.elevation2',
          opacity: open ? '1' : '0',
          transition: 'all 300ms',
          '.MuiTableCell-root': {
            py: open ? '24px' : '0',
            lineHeight: open ? 'auto' : '0',
            transition: 'all 300ms',
          },
        }}
      >
        <TableCell />
        <TableCell colSpan={2} sx={{ verticalAlign: 'top' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: open ? 2 : 0 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography lineHeight={'inherit'} fontWeight={700}>
                {t('components.costSidebar.table.body.description')}
              </Typography>
              <Typography lineHeight={'inherit'} sx={{ wordWrap: 'break-word', maxWidth: 228 }}>
                {cost.description}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography lineHeight={'inherit'} fontWeight={700}>
                {t('components.costSidebar.table.body.costCreateType')}
              </Typography>
              <Typography lineHeight={'inherit'} sx={{ wordWrap: 'break-word', maxWidth: 228 }}>
                {t(createTypesTranslationMapping[cost.costCreateType as keyof typeof createTypesTranslationMapping])}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography lineHeight={'inherit'} fontWeight={700}>
                {t('components.costSidebar.form.project')}
              </Typography>
              <Typography lineHeight={'inherit'} sx={{ wordWrap: 'break-word', maxWidth: 228 }}>
                {cost.project ? cost.project.acronym || cost.project.name || '-' : '-'}
              </Typography>
            </Box>
          </Box>
        </TableCell>
        <TableCell colSpan={2} sx={{ verticalAlign: 'top' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: open ? 2 : 0,
            }}
          >
            <Box>
              <Typography lineHeight={'inherit'} fontWeight={700}>
                {t('components.costSidebar.table.body.quantity')}
              </Typography>
              <Typography lineHeight={'inherit'}>{`${cost.quantity}x ${cost.amount} zł`}</Typography>
            </Box>

            <Box>
              <Typography lineHeight={'inherit'} fontWeight={700}>
                {t('components.costSidebar.table.body.startDate')}
              </Typography>
              <Typography lineHeight={'inherit'}>{formatStringDate(cost.startDate)}</Typography>
            </Box>

            <Box>
              <Typography lineHeight={'inherit'} fontWeight={700}>
                {t('components.costSidebar.table.body.endDate')}
              </Typography>
              <Typography lineHeight={'inherit'}>{formatStringDate(cost.endDate)}</Typography>
            </Box>
          </Box>
        </TableCell>
      </TableRow>
    </React.Fragment>
  )
}

export default CostRow
